<template>
  <router-view />
  <ToastContainer />
</template>
<script>
import { defineAsyncComponent } from 'vue'

export default {
  name: 'App',
  components: {
    ToastContainer: defineAsyncComponent(() => import('@/components/feedback/tailwind/ToastContainer.vue')),
  },
}
</script>
